import {
  IBudget,
  IBudgetPaymentMethod,
} from 'modules/checkout/domain/entities';

export type TPaymentMethodBlock =
  | { blocked: false }
  | { blocked: true; reason: 'INELIGIBLE'; message?: string }
  | { blocked: true; reason: 'CUSTOMER_PENDENCIES' }
  | { blocked: true; reason: 'UNAVAILABLE' };

/**
 * Por que esta forma de pagamento não pode ser usada neste orçamento.
 *
 * Duas das três regras vêm da tela antiga do carrinho e não tinham equivalente na tela
 * nova: a elegibilidade por forma, que o Vectis manda junto de cada forma de pagamento e
 * que o front descartava, e a inadimplência do cliente. Sem elas o cliente veria uma forma
 * que deveria estar bloqueada — e nada quebraria no caminho.
 *
 * A terceira já existia e é lida de onde sempre esteve, para não mexer no que a tela do
 * link faz hoje.
 */
export default function getPaymentMethodBlockingReason(params: {
  budget: IBudget;
  method: IBudgetPaymentMethod;
  customerHasPendencies: boolean;
}): TPaymentMethodBlock {
  const { budget, method } = params;

  if (method.eligibility?.eligible === false) {
    return {
      blocked: true,
      reason: 'INELIGIBLE',
      message: method.eligibility.message,
    };
  }

  const isRecurring = method.key === 'RECURRING_CARD';

  if (isRecurring && params.customerHasPendencies) {
    return { blocked: true, reason: 'CUSTOMER_PENDENCIES' };
  }

  if (budget.disabledPaymentMethods.includes(method.key)) {
    return { blocked: true, reason: 'UNAVAILABLE' };
  }

  return { blocked: false };
}
